// extracted by mini-css-extract-plugin
export default {"mobStickyFooter":"StickyFooter_mobStickyFooter__h8Wpr","menuContainer":"StickyFooter_menuContainer__4kMAy"};